export default __webpack_public_path__ + "static/media/3.78961d09.jpeg";